// src/hooks/useValidation.ts

// 프로필 정보 인터페이스 정의
import {useTranslation} from "react-i18next";

interface ProfileInfo {
  city: string;
  name: string;
  birthday: string;
  gender: string;
  address1: string;
  address2: string;
}

const useValidation = () => {
  const {t} = useTranslation("validation")
  // 각 필드에 대한 오류 메시지를 반환합니다.
  const validateName = (name: string) => {
    if (!name) {
      return t("name.unfilled");
    }
    if (!/^[a-zA-Z가-힣]+$/.test(name)) {
      return t("name.typeMismatch");
    }
    return "";
  };

  const validateBirthday = (birthday: string) => {
    if (!birthday) {
      return t("birthday.unfilled");
    }
    if (!/^\d{8}$/.test(birthday)) {
      return t("birthday.belowLength");
    }
    return "";
  };

  const validateGender = (gender: string) => {
    if (!gender) {
      return t("gender.unfilled");
    }
    return "";
  };

  // 전체 프로필 정보 유효성 검사
  const validateProfileInfo = (profileInfo: ProfileInfo) => {
    const nameError = validateName(profileInfo.name);
    const birthdayError = validateBirthday(profileInfo.birthday);
    const genderError = validateGender(profileInfo.gender);

    return {
      name: nameError,
      birthday: birthdayError,
      gender: genderError,
    };
  };

  return {
    validateProfileInfo,
    validateName,
    validateBirthday,
    validateGender,
  };
};

export default useValidation;
